<div class="wiz-box">
  <div class="heading">{{'wizard.step-5.title' | translate}}</div>
  <div class="wiz-content">
    <ng-container  *ngIf="!showResultPage; then importPart; else resultPart">
    </ng-container>
  </div>
  <div class="wiz-footer">
    <button class="secondary-btn" (click)="back(showImport)"><i
        class="fas fa-chevron-left"></i><span>{{'wizard.step-5.btn-back' | translate}}</span></button>
    <button class="primary-btn" [disabled]="isImportInProgress" (click)="next(showImport)"><span>{{'wizard.step-5.btn-continue' | translate}}</span><i
        class="fas fa-chevron-right"></i></button>
  </div>
</div>
<ng-template #resultPart>
  <div class="result-success">
    <div class="result-success-icon">
      <i class="far fa-check-circle"></i>
    </div>
    <div class="result-success-title">
      {{'wizard.step-5.import.p-1' | translate}}
    </div>
    <p>
      {{'wizard.step-5.import.p-2' | translate}}
    </p>
    <div *ngIf="importErrorMsgs?.length" class="modal-dialog-scrollable modal-body display-flex flex-column">
      <p class="warning strong">
        {{'modal-products-import.import.error' | translate}}
      </p>
      <div *ngFor="let err of importErrorMsgs">{{err}}</div>
    </div>
  </div>
</ng-template>
<ng-template #importPart>
  <p class="my-2 mb-3 text-muted">{{'wizard.step-5.p-1' | translate}}</p>
  <div class="num-item">
    <div class="num-item-top">
      <div class="num-item-num">1.</div>
      <p>
        <strong>{{'wizard.step-5.p-2.p-1' | translate}}</strong>
        <p-progressSpinner *ngIf="exportLoading; else link" class="small-spinner"></p-progressSpinner>
        <ng-template #link>
          <span class="link-red ml-1" (click)="downloadFile()">{{'wizard.step-5.p-2.p-2' | translate}}</span> {{'wizard.step-5.p-2.p-3' | translate}}
<!--          <a [href]="exportUrl" download="product-import.xlsx">{{'wizard.step-5.p-2.p-2' | translate}}</a> {{'wizard.step-5.p-2.p-3' | translate}}-->
        </ng-template>
      </p>
    </div>
  </div>
  <div class="num-item">
    <div class="num-item-top">
      <div class="num-item-num">2.</div>
      <label ngx-dropzone [disabled]="showProgress"  (change)="selected($event)" for="upload" class="styled-upload" [ngClass]="{'border-start': showStart, 'border-end': !showStart}">
        <ngx-dropzone-label *ngIf="!file" class="dropzone-label">
          <div class="d-flex align-items-center">
            <span class="icon"></span>
            <div class="dropzone-label-text">
              <span>{{'wizard.step-5.import' | translate}}</span>
              <span>{{'wizard.step-5.import-2' | translate}}</span>
            </div>
          </div>
        </ngx-dropzone-label>
        <ngx-dropzone-label *ngIf="file" class="dropzone-label">
          <div class="d-flex align-items-center">
            <span class="icon"></span>
            <div class="dropzone-label-text uploaded">
               <span>{{ "wizard.step-5.load-success"| translate }}</span>
               <span>{{this.file.name}}</span>
            </div>
          </div>
        </ngx-dropzone-label>
      </label>
    </div>
  </div>

  <div>
    <div *ngIf="!showValidationProgress; then thenBlock else elseBlock"></div>
    <ng-template #thenBlock>
      <div class="num-item">
        <div class="num-item-top">
          <div class="num-item-num">3.</div>
          <p>
            {{'wizard.step-5.confirm-import' | translate}}
          </p>
        </div>
      </div>
    </ng-template>
    <ng-template #elseBlock>
      <div class="num-item">
        <div class="num-item-top">
          <div class="num-item-num">3.</div>
          <p>
            {{'wizard.step-5.p-4.result' | translate}}
          </p>
        </div>
        <div *ngIf="itemCount > 0 && itemCount > errorList.length" class="wiz-line-list">
          <div class="wiz-line-item">
            <span>{{'wizard.step-5.total-records' | translate}}</span>
            <span>{{itemCount}}</span>
          </div>
          <div class="wiz-line-item">
            <span>{{'wizard.step-5.ok-records' | translate}}</span>
            <span *ngIf="!showStart">{{validationProgressValue}}</span>
            <span *ngIf="showStart">{{itemCount - errorList.length}}</span>
          </div>
          <div class="wiz-line-item">
            <span>{{'wizard.step-5.not-ok-records' | translate}}</span>
            <span [ngClass]="{'text-success': errorList.length === 0, 'text-danger': errorList.length > 0}">{{errorList.length}}</span>
          </div>
<!--          <div class="mt-2">-->
<!--            <p-progressBar *ngIf="file && isValidationRunning" [color]="'#ED1C24'" [showValue]="false"-->
<!--                           [value]="validationProgressValue / (itemCount - errorList.length) * 100">-->
<!--            </p-progressBar>-->
<!--            <ng-container *ngIf="file && isValidationRunning">{{validationProgressValue}}/{{itemCount - errorList.length}}</ng-container>-->
<!--          </div>-->
        </div>
        <div *ngIf="itemCount > 0 && itemCount === errorList.length" class="text-red">
          {{'wizard.step-5.all-errors' | translate}}
        </div>
        <button *ngIf="itemCount > 0 && itemCount === errorList.length" class="red-link"
                (click)="showInvalidData()">{{'wizard.step-5.btn-show-not-ok-records' | translate}}</button>
        <div *ngIf="!itemCount" class="text-red">
          {{'wizard.step-5.no-data' | translate}}
        </div>
        <div class="wiz-import-btns" *ngIf="itemCount > 0 && itemCount > errorList.length">
          <div [ngClass]="{'w-50': errorList.length !== 0, 'w-100': errorList.length === 0}">
            <p-progressBar *ngIf="showProgress; else elseBlock" [color]="'#ED1C24'" [showValue]="false"
                           [value]="progressValue / (itemCount - errorList.length) * 100">
            </p-progressBar>
            <ng-container *ngIf="showProgress">{{progressValue}}/{{itemCount - errorList.length}}</ng-container>
          </div>
          <ng-template #elseBlock><button *ngIf="showStart" class="primary-btn" (click)="import()">{{'wizard.step-5.btn-import' |
            translate}}</button></ng-template>
          <button *ngIf="errorList.length !== 0" class="red-link"
                  (click)="showInvalidData()">{{'wizard.step-5.btn-show-not-ok-records' | translate}}</button>
        </div>
        <div *ngIf="showSkipMessage && errorList.length > 0 && errorList.length !== itemCount" class="skip-row-text">{{'wizard.step-5.not-ok-rows-omit' | translate}}</div>
      </div>
    </ng-template>
  </div>
</ng-template>

